import * as React from 'react'
import styled from '@theme/styled-components'
import useI18n from '@store/i18n/useI18n'

interface Props {
  title: string
  value?: string
  placeholder?: string
}

const AdminTextValue = ({ title, value, placeholder }: Props) => {
  const i18n = useI18n()
  return (
    <Container>
      <Title>{title}</Title>
      <TextArea>{value || placeholder || i18n.t('common.placeholder.default')}</TextArea>
    </Container>
  )
}

export default AdminTextValue

const Container = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;

  margin: 5px;
`
const Title = styled('div')`
  font-family: Avenir;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  color: #9494a2;
`
const TextArea = styled('div')`
  display: flex;
  flex: 1;
  min-height: 50px;
  background: #ffffff;
  border: 1px solid #747474;
  box-sizing: border-box;
  border-radius: 7px;
  align-items: center;

  font-family: Avenir;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #6a6a6a;
  padding: 0 10px;
`
